import styled from "styled-components";
import { IThumbProps } from "react-range/lib/types";

interface StyledThumbProps extends IThumbProps {
  size: number;
}

export default styled.div<StyledThumbProps>`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
